export enum MessageProvider {
  Sendgrid = 'Sendgrid',
  Smtp = 'Smtp'
}
